import "./Navbar.css"
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const navigateToFAQ = (e) => {
    e.preventDefault();
    // First navigate to home page
    navigate('/');
    // Then scroll to FAQ section after a slight delay to ensure navigation completes
    setTimeout(() => {
      const faqElement = document.getElementById('faq');
      if (faqElement) {
        faqElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // Apply the same fix to the "Über uns" section
  const navigateToUberUns = (e) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => {
      const uberUnsElement = document.getElementById('uber-uns');
      if (uberUnsElement) {
        uberUnsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="/autozack_logo_nobg.png" alt="autozack Logo" className="logo-img" />
          <span className="brand-domain">.de</span>
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-expanded={menuOpen ? "true" : "false"}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link active" href="/">Home</a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" href="#wie-funktioniert-es">Wie es funktioniert</a>
            </li> */}
            <li className="nav-item">
              <a className="nav-link" href="#uber-uns" onClick={navigateToUberUns}>Über uns</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#faq" onClick={navigateToFAQ}>FAQ</a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/kontakt">Kontakt</Link>
            </li>
          </ul>
          <div className="d-flex">
            <Link to="/" className="btn btn-outline-light contact-button">
              Jetzt Auto verkaufen
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
